import { Modal } from 'components';
import styled from 'styled-components';

export const StyledModal = styled(Modal).attrs({
  wide: true,
})``;

export const ModalBody = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
`;

export const Toolbar = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 3px;
`;

export const SearchWrapper = styled.div`
  flex: 1;
`;

export const FilterButton = styled.button.attrs({
  className: 'btn btn-white',
})`
  flex-shrink: 0;
  white-space: nowrap;
  color: ${({ $active }) => ($active ? '#be1622' : undefined)};
  border-color: ${({ $active }) => ($active ? '#be1622' : undefined)};
`;

export const ScrollableWrapper = styled.div`
  overflow-y: auto;
  height: 100%;
`;

export const RetailersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  gap: 10px;
  padding: 10px;
  min-height: 0;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, minmax(150px, 1fr));
  }

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, minmax(150px, 1fr));
  }

  @media (max-width: 767px) {
    grid-template-columns: minmax(150px, 1fr);
  }
`;

export const RetailerCard = styled.div`
  display: flex;
  flex-direction: column;
  aspect-ratio: 1 / 1;
  background-color: white;
  border: 1px solid ${({ $selected }) => ($selected ? '#be1622' : '#e9ecef')};
  cursor: pointer;
  transition: border-color 0.15s;
  overflow: hidden;

  &:hover {
    border-color: ${({ $selected }) => ($selected ? '#a1131f' : '#ccc')};
  }
`;

export const RetailerImage = styled.img`
  width: 100%;
  flex: 1;
  object-fit: cover;
  background: #f0f0f0;
  min-height: 0;
`;

export const RetailerInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px 8px;
  flex-shrink: 0;
`;

export const RetailerName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RetailerEmail = styled.span`
  font-size: 12px;
  color: #999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EmptyState = styled.div`
  grid-column: 1 / -1;
  width: 100%;
  padding: 64px 20px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #6c757d;
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px 18px 16px;
  border-top: 1px solid #e9ecef;
  background: white;

  button {
    border-radius: 0;
    text-transform: uppercase;
  }
`;
